export default __webpack_public_path__ + "static/media/a1.4a2a9bc3.png";